// Sindhi translations
export const sd: Record<string, string> = {
  'menu.dashboard': 'ڊيش بورڊ',
  'menu.customers': 'گراهڪ',
  'menu.products': 'پراڊڪٽس',
  'menu.users': 'استعمال ڪندڙ',
  'menu.settings': 'سيٽنگون',
  'menu.logout': 'لاگ آئوٽ',
  'dashboard.title': 'ڊيش بورڊ',
  'dashboard.newOrder': 'نئون آرڊر',
  'order.title': 'نئون آرڊر',
  'order.customer': 'گراهڪ',
  'order.products': 'پراڊڪٽس',
  'order.total': 'ڪل',
  'users.title': 'استعمال ڪندڙ',
  'users.name': 'نالو',
  'users.email': 'اي ميل',
  'common.yes': 'ها',
  'common.no': 'نه',
  'common.cancel': 'منسوخ ڪريو',
  'common.save': 'محفوظ ڪريو',
  'common.search': 'ڳوليو',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'لاگ ان',
  'login.welcome': 'ڀليڪار, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'اي ميل',
  'signup.phone': 'فون',
  'menu.reportsAndAccounting': 'رپورٽون ۽ حساب ڪتاب',
  'menu.systemAndCommunication': 'سسٽم ۽ رابطو',
};